import { useSandbox } from '../sandbox/useSandbox'
import { useIsSmartContract } from './useIsSmartContract'
import { useConnectedAddress } from '@/domain/wallet/useConnectedAddress'

export type WalletType = 'gnosis-safe' | 'sandbox' | 'unknown' | string // string means connector type ie. 'walletconnect' or 'metamask'

export interface UseWalletTypeResult {
  walletType: WalletType | undefined
  isPending: boolean
}

export function useWalletType(): UseWalletTypeResult {
  const { account: address, connector } = useConnectedAddress({ throwOnNotConnected: false })
  const { isInSandbox } = useSandbox()
  const canBeGnosisSafe = connector?.name === 'WalletConnect' || connector?.name === 'Safe' // avoids querying bytecode if not needed
  const { isSmartContract, isPending } = useIsSmartContract(canBeGnosisSafe ? address : undefined)

  const walletType = (() => {
    if (!address) {
      return undefined
    }

    if (!canBeGnosisSafe) {
      if (isInSandbox) {
        return 'sandbox'
      }
      return connector?.name || 'unknown'
    }

    if (isSmartContract) {
      return 'gnosis-safe' // this assumes that Gnosis Safe is the only smart contract wallet
    }

    return undefined
  })()

  return {
    walletType,
    isPending: canBeGnosisSafe && isPending,
  }
}
